import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import SiteTableViewModel from "../../Licensing/Organisation/ViewModels/SiteTableViewModel";
import SiteTableRow from "./SiteTableRow";
interface IProps {
    organisationId: string
    refresh: () => void;
    siteCount: number;
    sitesTable: SiteTableViewModel | null;

}
export default function SiteTable({ organisationId, sitesTable, refresh }: IProps) {

    const refreshData = () => {
        refresh();
    }

    return (
        <TableContainer>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>Office Name</TableCell>
                        <TableCell>Town</TableCell>
                        <TableCell>Region</TableCell>
                        <TableCell>Country</TableCell>
                        <TableCell />
                    </TableRow>
                </TableHead>
                <TableBody>
                    {sitesTable?.rows.map((site, index) => (
                        <SiteTableRow key={index} row={site} orgId={organisationId} refreshData={refreshData} canArchive={sitesTable.rows.length > 1} />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
